if (!customElements.get('faq-search-component')) {
  customElements.define('faq-search-component', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.category = 'all-questions';
      this.input = this.querySelector('.faq-search-input');
      this.items = [...this.querySelectorAll('.faq-accordion-item')];
      this.dropdown = this.querySelector('.faq-mobile-dropdown');
      this.toggle = this.querySelector('.faq-dropdown-toggle');
      this.input?.addEventListener('input', () => this.filter(), options);
      this.addEventListener('click', (event) => {
        const choice = event.target.closest('.faq-nav-link, .faq-dropdown-option');
        if (choice && this.contains(choice)) {
          event.preventDefault();
          this.category = choice.dataset.categoryId;
          if (this.input) this.input.value = '';
          this.closeDropdown();
          this.filter();
        } else if (event.target.closest('.faq-dropdown-toggle')) {
          const open = this.dropdown.classList.toggle('open');
          this.toggle.setAttribute('aria-expanded', String(open));
        }
      }, options);
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.dropdown?.classList.contains('open')) {
          this.closeDropdown();
          this.toggle?.focus();
        }
      }, options);
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.closeDropdown();
      }, options);
      this.filter();
    }

    disconnectedCallback() { this.controller?.abort(); }

    closeDropdown() {
      this.dropdown?.classList.remove('open');
      this.toggle?.setAttribute('aria-expanded', 'false');
    }

    filter() {
      const query = this.input?.value.toLocaleLowerCase().trim() || '';
      const visibleCategories = new Set();
      this.classList.toggle('searching', Boolean(query));
      for (const item of this.items) {
        const matches = query
          ? [item.dataset.title, item.dataset.content, item.dataset.category].join(' ').toLocaleLowerCase().includes(query)
          : this.category === 'all-questions' || item.dataset.category === this.category;
        item.style.display = matches ? 'block' : 'none';
        if (matches) visibleCategories.add(item.dataset.category);
      }
      let firstVisible = true;
      for (const group of this.querySelectorAll('.faq-category-group')) {
        const category = group.querySelector('.faq-category-header')?.dataset.categoryId;
        const visible = visibleCategories.has(category);
        group.style.display = visible ? 'block' : 'none';
        group.classList.toggle('first-visible', visible && firstVisible);
        if (visible) firstVisible = false;
      }
      const active = query ? (visibleCategories.size === 1 ? [...visibleCategories][0] : 'all-questions') : this.category;
      for (const choice of this.querySelectorAll('.faq-nav-link, .faq-dropdown-option')) {
        choice.classList.toggle('active', choice.dataset.categoryId === active);
        choice.setAttribute('aria-current', choice.dataset.categoryId === active ? 'true' : 'false');
      }
      const label = this.querySelector('.faq-dropdown-current');
      const choice = [...this.querySelectorAll('.faq-dropdown-option')].find((item) => item.dataset.categoryId === active);
      if (label && choice) label.textContent = choice.textContent.trim();
      const empty = this.querySelector('.faq-empty-state');
      if (empty) empty.style.display = visibleCategories.size ? 'none' : 'flex';
    }
  });
}
